/* eslint-disable camelcase */

const en_US = require("../../translations/en_US");

export default {
  en_US
};
